export function decodeHtmlEntitiesOnce(input) {
    if (typeof input !== "string") return "";
    if (typeof document === "undefined") return input;
    const textarea = document.createElement("textarea");
    textarea.innerHTML = input;
    return textarea.value;
}

export function decodeHtmlEntities(input) {
    let out = typeof input === "string" ? input : "";
    for (let i = 0; i < 2; i += 1) {
        const next = decodeHtmlEntitiesOnce(out);
        if (next === out) break;
        out = next;
    }
    return out;
}

export function messageContainsHtmlTable(html) {
    if (typeof html !== "string") return false;
    const lower = html.toLowerCase();
    return (
        /<table[\s>/]/i.test(html) ||
        lower.includes("&lt;table") ||
        lower.includes("&#60;table")
    );
}

export function messageContainsHtmlChart(html) {
    if (typeof html !== "string") return false;
    const lower = html.toLowerCase();
    return (
        /<canvas[\s>/]/i.test(html) ||
        lower.includes("g2plot") ||
        lower.includes("attacktypepie") ||
        /renderpie/i.test(html) ||
        /<div[^>]+id=["'][^"']*(?:pie|chart)/i.test(html)
    );
}

// AI chart blocks: <script> tags and bare IIFEs (e.g. after a truncated block comment).
const SCRIPT_TAG_RE = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
const ORPHAN_CHART_SCRIPT_RE =
    /(?:\s*\*\/\s*)?(?:\/\*[\s\S]*?\*\/\s*)?(?:const\s+data\s*=\s*(?:\[[\s\S]*?\]|`[\s\S]*?`)\s*;?\s*)?\(?\s*function\s+render[\w$]*\s*\(\)\s*\{[\s\S]*\}\s*\)?\s*\(\s*\)\s*;?/gi;

export function extractChartScripts(html) {
    const scripts = [];
    let markup = html;

    markup = markup.replace(SCRIPT_TAG_RE, (_, code) => {
        const trimmed = (code || "").trim();
        if (trimmed) scripts.push(trimmed);
        return "";
    });

    markup = markup.replace(ORPHAN_CHART_SCRIPT_RE, (block) => {
        const code = block.replace(/^\s*\*\/\s*/, "").trim();
        if (code) scripts.push(code);
        return "";
    });

    markup = markup
        .replace(/\s*\*\/\s*/g, "")
        .replace(/G2Plot not found[\s\S]*?;?\s*/gi, "")
        .replace(/Note:\s*G2Plot library not found[\s\S]*?;?\s*/gi, "")
        .trim();

    return { markup, scripts };
}

export function findChartContainerId(html, scripts = []) {
    const src = [html, ...scripts].join("\n");
    const fromScript = src.match(
        /getElementById\s*\(\s*["']([^"']+)["']\s*\)/i
    );
    if (fromScript) return fromScript[1];
    const fromDiv = src.match(
        /<div[^>]+id=["']([^"']*(?:pie|chart|Pie|Chart)[^"']*)["']/i
    );
    if (fromDiv) return fromDiv[1];
    const pieCtor = src.match(/new\s+(?:G2Plot\.)?Pie\s*\(\s*["']([^"']+)["']/i);
    if (pieCtor) return pieCtor[1];
    return null;
}

export function parseChartDataFromSource(html, scripts = []) {
    const src = [...scripts, html].join("\n");
    const m = src.match(/const\s+data\s*=\s*(\[[\s\S]*?\])\s*;/);
    if (!m) return null;
    try {
        // eslint-disable-next-line no-new-func
        return new Function(`return ${m[1]}`)();
    } catch {
        return null;
    }
}

export function messageLooksLikeAiChart(content) {
    if (typeof content !== "string") return false;
    return (
        messageContainsHtmlChart(content) ||
        /\(function\s+renderPie/i.test(content) ||
        /new\s+G2Plot\.Pie/i.test(content)
    );
}

export function prepareAiHtmlContent(content) {
    if (typeof content !== "string") return "";

    let html = content.trim();
    html = html.replace(/^\s*```(?:html)?\s*/i, "").replace(/\s*```\s*$/g, "");

    const looksEscaped =
        html.includes("&lt;") &&
        (html.includes("&gt;") || html.includes("&amp;"));
    const looksLikeHtml = html.includes("<") || looksEscaped;

    if (looksEscaped && looksLikeHtml) {
        html = decodeHtmlEntities(html);
    }

    const { markup } = extractChartScripts(html);
    return markup;
}

export function prepareAiHtmlForRender(content) {
    if (typeof content !== "string") return { markup: "", scripts: [] };

    let html = content.trim();
    html = html.replace(/^\s*```(?:html)?\s*/i, "").replace(/\s*```\s*$/g, "");

    const looksEscaped =
        html.includes("&lt;") &&
        (html.includes("&gt;") || html.includes("&amp;"));
    if (
        looksEscaped &&
        (html.includes("<") || html.includes("&lt;"))
    ) {
        html = decodeHtmlEntities(html);
    }

    return extractChartScripts(html);
}
